import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Inverter, DeviceDetailService } from 'ngx-core-services';
import { map, switchMap, catchError, withLatestFrom, mapTo, first } from 'rxjs/operators';
import { of, from } from 'rxjs';

import {
  AppState,
  SystemsState,
  getSystemDefinitionConfiguration,
  requestSystemsDevicesStatus,
  selectedSystemMetadata,
  setSystemsDevicesStatusError,
  updateSystemsDevicesStatus,
} from '..';

@Injectable()
export class DeviceListEffects {

  requestDeviceListEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(requestSystemsDevicesStatus),
      switchMap((action) =>
        this.store.select(selectedSystemMetadata).pipe(
          first(),
          mapTo(action),
        ),
      ),
      withLatestFrom(this.store),
      switchMap(([action, { systemState }]) =>
        from(this.getSystemDeviceStatus(
            action.systemId,
            action.forceRefresh,
            systemState,
          )
        ).pipe(
          map((devices) => updateSystemsDevicesStatus({systemId: action.systemId, instanceId: action.instanceId, devices })),
          catchError((error) => of(setSystemsDevicesStatusError({ systemId: action.systemId, instanceId: action.instanceId, error: error.message }))),
        ),
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<AppState>,
    private readonly deviceDetailService: DeviceDetailService,
  ) {}

  async getSystemDeviceStatus(systemId: string, forceRefresh: boolean, state: SystemsState): Promise<{[key: string]: Partial<Inverter>}> {
    const system = state.systemList[systemId];

    if (!system) {
      throw new Error(`System with id ${systemId} not found`);
    }

    const systemConfiguration = getSystemDefinitionConfiguration(system);
    const serials = system.devices.map((device) => device.id);
    return this.deviceDetailService.fetchDevicesStatusInfo(serials, systemConfiguration.monitoringType, forceRefresh);
  }
}
